var timeout;
var elementsToFadeIn = document.querySelectorAll(
    '.-live main.content > .container-fluid > *, .overview-page__header > *, .packages-overview__packages > *, .detail-page__header > * '
);

// On page load:
fadeElementsInAndOut();
// again after waiting a bit, just to be sure:
setTimeout(function () {
    fadeElementsInAndOut();
}, 500);

function fadeElementsInAndOut() {
    [...elementsToFadeIn].forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(200px)';

        if (window.pageYOffset + window.innerHeight >= el.offsetTop) {
            // element is at least party in what user sees
            el.classList.add('faded-in');
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
        }
    });
}

function timeoutFadeElements() {
    if (!timeout) {
        timeout = setTimeout(function () {
            timeout = null;
            fadeElementsInAndOut();
        }, 100);
    }
}

// On resize and scroll:
window.addEventListener('scroll', timeoutFadeElements, false);
window.addEventListener('resize', timeoutFadeElements, false);
